import { render, staticRenderFns } from "./VerticalEbook.vue?vue&type=template&id=7ea4990e&scoped=true"
import script from "./VerticalEbook.vue?vue&type=script&lang=js"
export * from "./VerticalEbook.vue?vue&type=script&lang=js"
import style0 from "./VerticalEbook.vue?vue&type=style&index=0&id=7ea4990e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea4990e",
  null
  
)

export default component.exports